<ng-container *ngIf="mostrarGridLista">
  <form [formGroup]="formularioLineaDetalle" class="form-group" novalidate>
    <div class="row">
      <div *ngIf="!loading" class="form-group col-md-6 mb-2 d-flex align-items-center">
        <!--<ng-container>
          <a #btnAddMaterial class="btn btn-primary" data-bs-target="#materialModal" data-bs-toggle="modal"
             role="button">
            <span>Agregar Material</span>
            <i class="fa fa-tags"></i>
          </a>
        </ng-container>-->
      </div>
      <div *ngIf="!loading" class="form-group col-md-12 mb-2">
        <app-lfsa-input [control]="formularioLineaDetalle.get('dscaMaterial') | formControl"
                        [id]="'dscaMaterial'" [isReadOnly]="true" [label]="'Material*'"
                        [mostrarImg]="false"
                        [placeholder]="'Material'"
                        [rutaImagen]=""
                        formControlName="dscaMaterial">
        </app-lfsa-input>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-combo-box (change)="changeUnidad()"
                            [comboBox]="cmbUnidadMedida"
                            [control]="formularioLineaDetalle.get('idUnidad') | formControl"
                            [habilitar]="true"
                            [idOpcion]="'id'"
                            [id]="'idUnidad'"
                            [label]="'Unidad*'"
                            [opcion]="'descripcion'"
                            formControlName="idUnidad">
        </app-lfsa-combo-box>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-input [control]="formularioLineaDetalle.get('precio') | formControl" [id]="'precio'"
                        [isReadOnly]="true" [label]="'Precio*'"
                        [mostrarImg]="false"
                        [placeholder]="'Precio'"
                        [rutaImagen]=""
                        [type]="'number'"
                        formControlName="precio">
        </app-lfsa-input>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-input [control]="formularioLineaDetalle.get('cantidad') | formControl" [id]="'cantidad'"
                        [isReadOnly]="true"
                        [label]="'Cantidad*'"
                        [mostrarImg]="false"
                        [placeholder]="'Cantidad'"
                        [rutaImagen]=""
                        [type]="'number'"
                        formControlName="cantidad">
        </app-lfsa-input>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-input [control]="formularioLineaDetalle.get('importe') | formControl" [id]="'importe'"
                        [isReadOnly]="true" [label]="'Importe*'"
                        [mostrarImg]="false"
                        [placeholder]="'Importe'"
                        [rutaImagen]=""
                        [type]="'number'"
                        formControlName="importe">
        </app-lfsa-input>
      </div>
    </div>
    <!--  <app-lfsa-botones-formularioLineaDetalle (devolverAccion)="acciones( $event )" [botonRegresar]="false"
                                   [formularioLineaDetalleValido]="formularioLineaDetalle.invalid"
                                   [loading]="loading" [textBoton]="textBoton">
      </app-lfsa-botones-formularioLineaDetalle>-->


    <div *ngIf="!loading" class="row mt-3">
      <div class="col-md-6 offset-md-6">
        <!--<div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" [disabled]="formularioLineaDetalle.invalid"
                    class="btn btn-outline-success">
              <i aria-hidden="true" class="fa fa-plus"></i>
              {{DAT_BTNS.agregar}}
            </button>
          </div>
        </div>-->
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12 ">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!loading" [columnDefs]="columnDefs"
                         [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                         [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                         [pagination]="true" [rowData]="rowData"
                         [rowSelection]="rowSelection" class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.id}}">
        </ag-grid-angular>
      </div>
    </div>

    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                 [loading]="loading"

                                 [mostrarBotonVerde]="false" [textBoton]="textBoton">
    </app-lfsa-botones-formulario>

  </form>
</ng-container>

<ng-container *ngIf="!mostrarGridLista">
  <app-selector-imputacion [solicitudData]="solicitudData"></app-selector-imputacion>
</ng-container>
